import React from 'react';
import { FadeIn } from './FadeIn';
export function PainPoints() {
  const pains = ['Improvisás en consulta y lo sabés.', 'Armás planes desde cero cada vez. Horas perdidas.', 'No tenés protocolos claros para patologías complejas.', 'Te falta evidencia para respaldar tus decisiones.'];
  return <section className="pt-6 pb-8 px-3" data-id="element-179">
      <div className="max-w-3xl mx-auto" data-id="element-180">
        <FadeIn data-id="element-181">
          <h2 className="text-center font-display text-2xl md:text-3xl font-bold text-accent mb-5" data-id="element-182">
            Esto te pasa en consulta
          </h2>
        </FadeIn>

        <div className="space-y-2.5" data-id="element-183">
          {pains.map((pain, idx) => <FadeIn key={idx} delay={0.08 * idx} data-id="element-184">
              <div className="flex items-center gap-3 bg-surface border border-red-500/20 rounded-lg px-4 py-2.5" data-id="element-185">
                <span className="text-red-400 text-base shrink-0" data-id="element-186">✗</span>
                <p className="text-white/85 text-sm md:text-base font-medium" data-id="element-187">
                  {pain}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} data-id="element-188">
          <p className="text-center text-base md:text-lg italic max-w-2xl mx-auto font-[800] font-['Open_Sans',_sans-serif] text-accent mt-5" data-id="element-189">
            No necesitás más cursos. Necesitás un sistema clínico.
          </p>
        </FadeIn>
      </div>
    </section>;
}